import { render, staticRenderFns } from "./core_embed.vue?vue&type=template&id=0d052845"
import script from "./core_embed.vue?vue&type=script&lang=js"
export * from "./core_embed.vue?vue&type=script&lang=js"
import style0 from "./core_embed.vue?vue&type=style&index=0&id=0d052845&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports